<template>
  <section>
    <div class="vld-parent">
      <loading
        :active.sync="loading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="false"
        :background-color="bgColor"
        :opacity="opacity"
      ></loading>

      <b-card>
        <b-card-text>
          <b-container>
            <b-row>
              <b-col>
                <h6>Estimated Cost of Service for Electricity in 2050:</h6>
              </b-col>
            </b-row>

            <b-col class="no-gutter">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Without Electricity Storage</th>
                    <th>With Electricity Storage</th>
                  </tr>
                </thead>
                <tr>
                  <td>Total Cost</td>
                  <td>¢{{totalElecCostNoStorageGetter}}/kWh</td>
                  <td>¢{{totalElecCostStorageGetter}}/kWh</td>
                </tr>
                <tr>
                  <td>Fixed (Capital) Cost</td>
                  <td>¢{{capitalElecCostNoStorageGetter}}/kWh</td>
                  <td>¢{{capitalElecCostStorageGetter}}/kWh</td>
                </tr>
                <tr>
                  <td class="table-space">Var. (Operating) Cost</td>
                  <td class="table-space">¢{{operatingElecCostNoStorageGetter}}/kWh</td>
                  <td class="table-space">¢{{operatingElecCostStorageGetter}}/kWh</td>
                </tr>
                <tr class="table-total">
                  <td>Total Cost Per Customer</td>
                  <td>${{elecCostPerCustomerNoStorageGetter}}/year</td>
                  <td>${{elecCostPerCustomerStorageGetter}}/year</td>
                </tr>
<!--                 <tr>
                  <td>Total Cost Per Person</td>
                  <td>${{elecCostPerPersonNoStorageGetter}}/year</td>
                  <td>${{elecCostPerPersonStorageGetter}}/year</td>
                </tr> -->
              </table>

              <h6>2050 Power Plant Summary: Generation, Capacity, and Land Use:</h6>

              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Without Electricity Storage</th>
                    <th>With Electricity Storage</th>
                  </tr>
                </thead>
                <tr>
                  <td>Net Generation</td>
                  <td>{{totalNetGenNoStorage}} TWh</td>
                  <td>{{totalNetGenStorage}} TWh</td>
                </tr>
                <tr>
                  <td>Power Plant Capacity</td>
                  <td>{{powerPlantCapacityNoStorage}} MW</td>
                  <td>{{powerPlantCapacityStorage}} MW</td>
                </tr>
                <tr>
                  <td>Storage Cap. (Power)</td>
                  
                  <td>N/A</td>
                  <td>{{storageCapPower}} MW</td>
                  
                </tr>
                <tr>
                  <td>Storage Cap. (Energy)</td>
                  <td>N/A</td>
                  <td>{{storageCapEnergy}} TWh</td>
                </tr>
                <tr>
                  <td>Land Use, direct area (1000s acres)</td>
                  <td>{{getLandUseNoStorageDirect}}</td>
                  <td>{{getLandUseStorageDirect}}</td>
                </tr>
                <tr>
                  <td>Land Use, direct area (% of accessed regions)</td>
                  <td>{{getLandUsePercentNoStorageDirect}}%</td>
                  <td>{{getLandUsePercentStorageDirect}}%</td>
                </tr>
                <tr>
                  <td>Land Use, total area (1000s acres)</td>
                  <td>{{getLandUseNoStorage}}</td>
                  <td>{{getLandUseStorage}}</td>
                </tr>
                <tr>
                  <td>Land Use, total area (% of accessed regions)</td>
                  <td>{{getLandUsePercentNoStorage}}%</td>
                  <td>{{getLandUsePercentStorage}}%</td>
                </tr>
              </table>
            </b-col>
          </b-container>
          <br />
          <b-container>
            <highcharts id="summaryChart" :options="chartOptionsOne"></highcharts>
          </b-container>

        </b-card-text>
      </b-card>

    </div>
  </section>
</template>

<script>
import { Chart } from 'highcharts-vue';
import JQuery from 'jquery';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

let $ = JQuery;

import { mapGetters } from 'vuex';

export default {
  name: 'Summary',
  props: ['summaryData', 'summaryDataNoStorage', 'inputData', 'isLoading'],

  data() {
    return {
      // loader
      loading: true,
      fullPage: false,
      bgColor: '#fff',
      opacity: 0.5,
      //
      
      selected: 'storage0',
      options: [
        { text: 'Storage', value: 'storage0' },
        { text: 'Without Storage', value: 'storage1' }
      ]
    };
  },
  components: {
    highcharts: Chart,
    Loading
  },
  computed: {
    ...mapGetters(['storageCapPower', 
      'powerPlantCapacityStorage',
      'powerPlantCapacityNoStorage', 
      'totalNetGenStorage', 
      'totalNetGenNoStorage',
      'storageCapEnergy',
      'storageCapPowerNoStorage',
      'storageCapEnergyNoStorage',
      'totalElecCostStorageGetter',
      'totalElecCostNoStorageGetter',
      'capitalElecCostStorageGetter',
      'capitalElecCostNoStorageGetter',
      'operatingElecCostStorageGetter',
      'operatingElecCostNoStorageGetter',
      'elecCostPerCustomerStorageGetter',
      'elecCostPerCustomerNoStorageGetter',
      'elecCostPerPersonStorageGetter',
      'elecCostPerPersonNoStorageGetter',
      'getLandUsePercentStorage',
      'getLandUsePercentNoStorage',
      'getLandUseStorage',
      'getLandUseNoStorage',
      'getLandUsePercentStorageDirect',
      'getLandUsePercentNoStorageDirect',
      'getLandUseStorageDirect',
      'getLandUseNoStorageDirect'
    ]),
    chartOptionsOne() {
        return {
          credits: {
            enabled: false
          },
          chart: {
            type: 'column',
            height: 300,
            // width: 500
          },
          title: {
            text: 'User Inputs & Solved Technology Percentage for Electricity Generation in 2050'
          },
          xAxis: {
            categories: [
              'Natural Gas',
              'Geothermal',
              'Nuclear',
              'Petroleum',
              'Hydro',
              'Biosmass',
              'Wind',
              'Solar PV',
              'Solar CSP',
              'Coal'
            ]
          },
          yAxis: {
            title: undefined,
            min: 0,
            max: 100
          },
          tooltip: {
            formatter: function() {
              var s;
              s = this.series.name + ': ' + '\n' + this.x + ' ' + this.y.toFixed(1) + '%';
              return s;
            },
            valueDecimal: 1,
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [
            {
              name: 'With Storage',
              data: [this.summaryData["Natural Gas"], 
                this.summaryData["Geothermal"], 
                this.summaryData["Nuclear"],
                this.summaryData["Petroleum"],
                this.summaryData["Hydro"],
                this.summaryData["Biomass"],
                this.summaryData["Wind"],
                this.summaryData["Solar PV"],
                this.summaryData["Solar CSP"],
                this.summaryData["Coal"] ]
            },
            {
              name: 'Without Storage',
              data: [this.summaryDataNoStorage["Natural Gas"], 
                this.summaryDataNoStorage["Geothermal"], 
                this.summaryDataNoStorage["Nuclear"],
                this.summaryDataNoStorage["Petroleum"],
                this.summaryDataNoStorage["Hydro"],
                this.summaryDataNoStorage["Biomass"],
                this.summaryDataNoStorage["Wind"],
                this.summaryDataNoStorage["Solar PV"],
                this.summaryDataNoStorage["Solar CSP"],
                this.summaryDataNoStorage["Coal"] ]
            },
            {
              name: 'User Inputs',
              data: [this.inputData["Natural Gas"], 
                this.inputData["Geothermal"], 
                this.inputData["Nuclear"],
                this.inputData["Petroleum"],
                this.inputData["Hydro"],
                this.inputData["Biomass"],
                this.inputData["Wind"],
                this.inputData["Solar PV"],
                this.inputData["Solar CSP"],
                this.inputData["Coal"] ]
            }
          ]
        }
      },
  },
  watch: {
    isLoading() {
      this.loading = this.isLoading;
    }
  },
  methods: {
    onCancel() {} // loader cancel
  },
  mounted() {
    this.loading = true;
    // simulate AJAX
    setTimeout(() => {
      this.loading = false;
    }, 3000),
      $('.highcharts-container').css({
        'margin-left': '-1rem',
        'margin-right': '-1rem',
        height: '300px'
      });
  }
};
</script>

<style lang="scss" scoped>
#summaryChart {
  // margin-left: 1%
  padding-left: 1%
} 
h6 {
  margin-top: 0.5rem;
}

h7 {
  font-weight: bold;
}

.no-gutter {
  padding: 0;
}

.container {
  padding: 0;
}

.tab-pane:focus {
  outline: none !important;
}

.form-group {
  margin: 0;
}

.btn-group-toggle {
  width: 100%;
}

table {
  margin: 1rem 0;
  font-size: 0.85rem;

  thead {
    font-size: 0.7rem;
  }

  th {
    padding-right: 1rem;
  }

  tr {
    td {
      padding: 0.5rem 1.5rem 0 0;
    }
  }

  .table-space {
    padding-bottom: 10px;
  }

  .table-total {
    padding-top: 1rem;
    td {
      // font-weight: bold;
      border-top: 1px solid gray;
      padding: 0.5rem 0 0.5rem 0;
    }
  }
}
</style>
